import { type ComponentProps } from "react";
import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/v2/badge";
import { CAMPAIGN_INTEGRATION_STATUS_CONFIG } from "@/features/campaigns/jobboards/constants";
import {
  getCampaignIntegrationStatus,
  type CampaignIntegrationStatusInput,
} from "@/features/campaigns/jobboards/utils/getCampaignIntegrationStatus";

type CampaignIntegrationStatusBadgeProps = {
  campaignIntegration: CampaignIntegrationStatusInput;
  size?: ComponentProps<typeof Badge>["size"];
};

/**
 * Status only — never a control. Pausing and resuming go through
 * `CampaignIntegrationPauseButton` on the integration detail page: a chip that stops distribution
 * when clicked gives no affordance, and on the list card it sat inside a click-to-navigate row.
 */
function CampaignIntegrationStatusBadge({
  campaignIntegration,
  size,
}: CampaignIntegrationStatusBadgeProps) {
  const { t } = useTranslation();

  const { labelKey, variant } =
    CAMPAIGN_INTEGRATION_STATUS_CONFIG[getCampaignIntegrationStatus(campaignIntegration)];

  return (
    <Badge variant={variant} size={size}>
      {t(labelKey)}
    </Badge>
  );
}

export default CampaignIntegrationStatusBadge;
